import { TextField } from "@mui/material";

const Input = ({ meta: { touched, error }, input: inputProps, ...props }) => (
    <TextField
        sx={{ mt: "1em" }}
        error={!!(touched && error)}
        helperText={touched && error}
        {...inputProps}
        {...props}
        fullWidth />
)

export default Input